<template>
  <div>
    <div id="header" class="header navbar-default">
      <div class="navbar-header">
        <img
          src="../../assets/palu-pakagali.png"
          alt="logo"
          style="width: 200px; padding: 5px 5px 5px 10px"
        />
        <button
          type="button"
          class="navbar-toggle pt-0 pb-0 mr-0 collapsed"
          v-on:click="toggleMobileTopMenu"
          v-if="pageOptions.pageWithTopMenu && !pageOptions.pageWithoutSidebar"
        >
          <span class="fa-stack fa-lg text-inverse">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileTopMenu"
          v-if="pageOptions.pageWithTopMenu && pageOptions.pageWithoutSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button
          type="button"
          class="navbar-toggle"
          v-on:click="toggleMobileSidebar"
          v-if="!pageOptions.pageWithoutSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <ul class="navbar-nav navbar-right">
        <b-nav-item-dropdown
          menu-class="media-list dropdown-menu-right"
          toggle-class="f-s-14"
          no-caret
        >
          <template slot="button-content">
            <i class="fa fa-bell"></i>
            <span class="label" v-if="totalNotif >= 1">{{ totalNotif }}</span>
          </template>
          <b-dropdown-header
            >NOTIFICATIONS ({{ totalNotif }})</b-dropdown-header
          >
          <b-dropdown-item
            v-for="notif in listNotif"
            :key="notif.id"
            href="javascript:;"
            class="media"
            ><router-link
              :to="'/pengaduan/detail/' + notif.report_id"
              style="text-decoration: none"
            >
              <div class="d-flex">
                <div class="media-left">
                  <i class="fa fa-bullhorn media-object bg-silver-darker"></i>
                </div>
                <div class="media-body">
                  <h6 class="media-heading">{{ notif.customer_name }}</h6>
                  <p>{{ notif.complaint }} <br /></p>
                  <div class="text-muted f-s-10">
                    {{ indonesianFormat(notif.created_at) }}
                  </div>
                </div>
              </div></router-link
            >
          </b-dropdown-item>
          <b-dropdown-item href="javascript:;" class="text-center">
            <router-link to="/pengaduan">View more </router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown
          menu-class="dropdown-menu-right"
          class="dropdown navbar-user"
          no-caret
        >
          <template slot="button-content">
            <img src="@/assets/img/user.png" alt="" />
            <span class="d-none d-md-inline">{{ userFullName }}</span>
            <b class="caret"></b>
          </template>
          <b-dropdown-item href="javascript:;">{{ userName }}</b-dropdown-item>
          <!-- <b-dropdown-item href="javascript:;" v-on:click="openProfil"
            >Profile</b-dropdown-item
          > -->
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="javascript:;" v-on:click="logout"
            >Log Out</b-dropdown-item
          >
        </b-nav-item-dropdown>
      </ul>
    </div>
  </div>
</template>

<script>
import PageOptions from "@/config/PageOptions.vue";
import Swal from "sweetalert2";
import moment from "moment";
import userData from "@/plugins/userData";
import fetchNotif from "@/plugins/notifications";
import packageJson from "@/../package.json";

export default {
  name: "HeaderComponent",
  mixins: [userData, fetchNotif],
  data() {
    return {
      pageOptions: PageOptions,
      appName: packageJson.title,
      appDescription: packageJson.description,
      totalNotif: 0,
      listNotif: [],
    };
  },
  mounted() {
    this.fetchNotif();
  },
  // watch: {
  //   $route() {
  //     this.fetchNotif();
  //   },
  //   totalNotif() {
  //     this.fetchNotif();
  //   },
  // },
  methods: {
    indonesianFormat(dateTime) {
      return moment.unix(dateTime).format("D MMMM YYYY");
    },

    logout() {
      Swal.fire({
        title: "Apakah Anda Akan Logout ?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Logout!",
      }).then((result) => {
        if (result.value) {
          localStorage.removeItem("userData");
          if (this.$route.path !== "/login") {
            this.$router.push("/login");
          }
        }
      });
    },
    openProfil() {
      this.$router.push("/profil");
    },
    toggleMobileSidebar() {
      this.pageOptions.pageMobileSidebarToggled =
        !this.pageOptions.pageMobileSidebarToggled;
    },
    toggleMobileRightSidebar() {
      this.pageOptions.pageMobileRightSidebarToggled =
        !this.pageOptions.pageMobileRightSidebarToggled;
    },
    toggleMobileTopMenu() {
      this.pageOptions.pageMobileTopMenu = !this.pageOptions.pageMobileTopMenu;
    },
    toggleMobileMegaMenu() {
      this.pageOptions.pageMobileMegaMenu =
        !this.pageOptions.pageMobileMegaMenu;
    },
    toggleRightSidebar() {
      this.pageOptions.pageRightSidebarToggled =
        !this.pageOptions.pageRightSidebarToggled;
    },
    toggleRightSidebarCollapsed() {
      this.pageOptions.pageRightSidebarCollapsed =
        !this.pageOptions.pageRightSidebarCollapsed;
    },
    handleSidebarMinify: function () {
      this.pageOptions.pageSidebarMinified =
        !this.pageOptions.pageSidebarMinified;
    },
    checkForm: function (e) {
      e.preventDefault();
      this.$router.push({ path: "/extra/search" });
    },
  },
};
</script>
